const errorHandler = (error) => {

  if (!error.response) {
    return "network_error";
  }

  const status = error.response.status;

  switch (status) {
    case 400:
      return "bad_request";

    case 401:
      return "unauthorized";

    case 403:
      return "forbidden";

    case 404:
      return "not_found";

    case 500:
      return "server_error";

    default:
      return "unknown_error";
  }
};

export default errorHandler;
